import React, { useEffect, useState } from 'react';
import store from '../../store';
import logo from '../../resources/img/logo/ua.png';
import { bridgeContext, panelSessionBridge } from './bridge';

export default function SorobanIdBridge() {
    const [error, setError] = useState(false);
    useEffect(() => {
        let active = true;
        let context;
        try {
            context = bridgeContext(window.location.search, process.env.REACT_APP_SOROBAN_ID_ORIGIN);
        } catch {
            setError(true);
            return undefined;
        }
        panelSessionBridge(context, store.getState().user, process.env.REACT_APP_API_V2_URL)
            .then(target => { if (active) window.location.replace(target); });
        return () => { active = false; };
    }, []);
    return (
        <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f4f6f8', padding: 24 }}>
            <section style={{ maxWidth: 440, width: '100%', padding: 32, borderRadius: 16, background: '#fff', boxShadow: '0 16px 32px -4px rgb(145 158 171 / 24%)' }}>
                <img src={logo} alt="Soroban" width="168" />
                <h1 style={{ fontSize: 24, marginTop: 28 }}>{error ? 'Unable to continue' : 'Signing in with Soroban ID'}</h1>
                <p role="status" style={{ color: '#637381', lineHeight: 1.6 }}>
                    {error ? 'Go back to Soroban ID and sign in with your email and password.' : 'Checking your saved Soroban session. You will return automatically.'}
                </p>
            </section>
        </main>
    );
}
